/** Normaliza texto para comparação: minúsculas, sem acentos, espaços colapsados. */
export const normalizeText = (value: string | undefined | null): string =>
  (value ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

export const MAX_NAME_LENGTH = 80;
export const MAX_NOTES_LENGTH = 300;
export const MAX_FLIGHT_LENGTH = 12;
export const MAX_PHONE_DIGITS = 15;

const isControlChar = (char: string) => {
  const code = char.charCodeAt(0);
  return code < 32 || code === 127;
};

/** Remove caracteres de controle, limita o tamanho e apara espaços. */
export const clampText = (value: string | undefined, max: number): string =>
  Array.from(value ?? "")
    .map((char) => (isControlChar(char) ? " " : char))
    .join("")
    .slice(0, max)
    .trim();

export const onlyDigits = (value: string | undefined): string =>
  (value ?? "").replace(/\D/g, "").slice(0, MAX_PHONE_DIGITS);
